export default __webpack_public_path__ + "static/media/TrendUp.8bd20e65.svg";